import React from 'react';

import PlayersTable from '../../components/Table/PlayersTable';

const Players = () => (
  <div className="content">
    <PlayersTable />
  </div>
);

export default Players;


// WEBPACK FOOTER //
// ./src/pages/Players/index.js